module.exports = __webpack_public_path__ + "static/media/Kegstar-logo.97b296d3.svg";